(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-td-aisle-landing"] && !Shopify.designMode) return;
  try {
    
  /**
   * Aisle Form Customization
   * Observes for form injection and modifies elements:
   * - Changes button text to "SEND THE DEETS"
   * - Reorders elements: input → button → terms
   */
  (function() {
    const targetId = "aisle-form-submit";
    
    /**
     * Handles error visibility - shows only one error at a time (phone errors take priority)
     * @param {HTMLElement} container - The form container element
     */
    function handleErrorVisibility(container) {
      const errorSelectors = [
        '.aisle-form-input-text-error',
        '[class*="error"]:not(input):not(button)',
        '[role="alert"]'
      ];
      
      const errors = container.querySelectorAll(errorSelectors.join(', '));
      if (errors.length <= 1) return;
      
      let phoneError = null;
      let firstError = null;
      
      errors.forEach((error) => {
        // Check if this is a phone-related error
        const text = error.textContent.toLowerCase();
        if (!phoneError && (text.includes('phone') || text.includes('number') || text.includes('valid'))) {
          phoneError = error;
        }
        if (!firstError) firstError = error;
        
        // Hide all errors initially
        error.style.display = 'none';
      });
      
      // Show only the priority error (phone first, otherwise first error)
      const errorToShow = phoneError || firstError;
      if (errorToShow) {
        errorToShow.style.display = '';
      }
    }
    
    /**
     * Modifies the Aisle form elements
     * @param {HTMLElement} container - The form container element
     */
    function customizeAisleForm(container) {
      // Change button text
      const button = container.querySelector('.aisle-form-button');
      if (button && button.textContent !== 'SEND THE DEETS') {
        button.textContent = 'SEND THE DEETS';
      }
      
      // Force order via inline styles to override any Aisle styles
      const formContainer = container.querySelector('.aisle-form-container');
      if (formContainer) {
        formContainer.style.display = 'flex';
        formContainer.style.flexDirection = 'column';
      }
      
      const input = container.querySelector('.aisle-form-input-text');
      if (input) {
        input.style.order = '0';
      }
      
      const buttonContainer = container.querySelector('.aisle-form-button-container');
      if (buttonContainer) {
        buttonContainer.style.order = '1';
      }
      
      const legalContainer = container.querySelector('.aisle-form-legal-container');
      if (legalContainer) {
        legalContainer.style.order = '2';
      }
      
      // Handle error visibility - show only one error at a time
      handleErrorVisibility(container);
    }
    
    /**
     * Sets up MutationObserver to watch for form injection
     * @param {HTMLElement} targetElement - The target container element
     */
    function setupObserver(targetElement) {
      // Check if form already exists
      const existingForm = targetElement.querySelector('.aisle-form-container');
      if (existingForm) {
        customizeAisleForm(targetElement);
      }
      
      // Watch for future changes
      const observer = new MutationObserver((mutations) => {
        customizeAisleForm(targetElement);
      });
      
      observer.observe(targetElement, { childList: true, subtree: true });
    }
    
    /**
     * Initializes the form customization
     */
    function init() {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        setupObserver(targetElement);
      }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
